import User from 'flarum/common/models/User';
import classList from 'flarum/common/utils/classList';
import RecipientLabel from './RecipientLabel';
export default function recipientsLabel(recipients, attrs = {}) {
  const {
    link,
    className,
    ...otherAttrs
  } = attrs;
  otherAttrs.className = classList('RecipientsLabel', className);
  return m("span", otherAttrs, recipients?.map((recipient, index) => {
    const type = recipient instanceof User ? 'u' : 'g';
    return m(RecipientLabel, {
      key: `${type}-${index}`,
      recipient: recipient,
      link: link
    });
  }), !recipients && m(RecipientLabel, null));
}
flarum.reg.add('fof-byobu', 'forum/pages/labels/recipientsLabels', recipientsLabel);